module.exports = __webpack_public_path__ + "static/fipcbrownsafari3-184686645f0b2766276c15742f2be9e4.jpeg";